import { useEffect, useState } from 'react';

// One breakpoint for the shared charts' phone presentation.
export const COMPACT_CHART_QUERY = '(max-width: 639px)';
export function useCompactChart() {
  const [compact, setCompact] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(COMPACT_CHART_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia?.(COMPACT_CHART_QUERY);
    if (!query) return undefined;
    const update = () => setCompact(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return compact;
}
